var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6704_46386)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5.3877,
    stroke: "#5C5C5C",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.65271,
    y: 4.58984,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.65234,
    y: 17.4629,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3876,
    y: 4.58984,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.3877,
    y: 17.4629,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6704_46386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichLight);
export default __webpack_public_path__ + "static/media/rich-light.6efebe3aa96c1d1a051a51b15961d7e1.svg";
export { ForwardRef as ReactComponent };